import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthProfile } from "../../utils/useAuthProfile";
import { useToasts } from "../../providers/notifications/ToastsContext";

const NotAuthenticated: React.FC = () => {
  const [userProfile, , removeToken] = useAuthProfile();
  const { showToast } = useToasts();

  if (userProfile) {
    // session expired
    removeToken();
    showToast({
      resourceType: "General",
      strapiId: "auth_session_expired",
    });
  }

  return <Navigate replace to="/login" />;
};

export default NotAuthenticated;
